import React from "react";
import EntityType from "../EntityType";
import SuggestionsPicker from "./SuggestionsPicker";
import GenericSuggestionsPickerProps from "./GenericSuggestionsPickerProps";
import TeamPickerSelected from "./suggestionsPickerSelected/TeamPickerSelected";
import {
  buildGetItemUrl,
  buildSuggestItem,
  getIdFromSuggestItem,
} from "./utils/teamPickerUtils";

/**
 * Reusable team picker component.
 *
 * @param {*} props
 * @returns {JSX.Element}
 */
const TeamPicker: React.FC<GenericSuggestionsPickerProps> = (
  props
): JSX.Element => {
  return (
    <SuggestionsPicker
      {...props}
      placeholder="Search..."
      buildGetItemUrl={buildGetItemUrl}
      buildSuggestItem={buildSuggestItem}
      getIdFromSuggestItem={getIdFromSuggestItem}
      suggestionTypes={[EntityType.TEAM]}
      suggestionsSelectedComponent={TeamPickerSelected}
    />
  );
};

export default TeamPicker;
